import React, { useState } from "react";
import axios from "axios";
import { MdOutlineComputer, MdPerson, MdLock, MdErrorOutline, MdLogin } from "react-icons/md";
import "./Login.css";

const API = "https://daily-report.spectratally.net/api";

export default function Login({ onLogin }) {
  const [form, setForm]       = useState({ username:"", password:"" });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, form);
      if (res.data.success) onLogin(res.data.data);
    } catch(err) {
      setError(err.response?.data?.message || "Login failed. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-left-content">
          <div className="login-brand-icon"><MdOutlineComputer /></div>
          <h1>Daily Office<br/>Work Report</h1>
          <p>Track your daily work, manage tasks, and generate reports effortlessly.</p>
          <div className="login-features">
            {["Role-based access control","Task assignment & tracking","Daily report generation","Print-ready PDF reports"].map(f => (
              <div className="login-feature-item" key={f}>
                <span className="feature-dot" />{f}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-card">
          <div className="login-card-header">
            <h2>Sign In</h2>
            <p>Enter your credentials to access the portal</p>
          </div>
          {error && (
            <div className="login-error">
              <MdErrorOutline /><span>{error}</span>
            </div>
          )}
          <form onSubmit={handleSubmit} className="login-form">
            <div className="lf-group">
              <label>Username</label>
              <div className="lf-input-wrap">
                <MdPerson className="lf-icon" />
                <input type="text" placeholder="Enter your username" autoComplete="username"
                  value={form.username} onChange={e=>setForm({...form,username:e.target.value})} required />
              </div>
            </div>
            <div className="lf-group">
              <label>Password</label>
              <div className="lf-input-wrap">
                <MdLock className="lf-icon" />
                <input type="password" placeholder="Enter your password" autoComplete="current-password"
                  value={form.password} onChange={e=>setForm({...form,password:e.target.value})} required />
              </div>
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? <><span className="spinner" /> Signing in...</> : <><MdLogin /> Sign In</>}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
